import {
  createRouter,
  createWebHashHistory,
  RouteLocationNormalized,
  RouteLocationRaw,
  RouteRecordRaw,
} from 'vue-router'

import AuthStore from '@/store/AuthStore'

type AppRoute = RouteRecordRaw & {
  meta?: {
    isPublic?: boolean
    // Collapse the sidebar to a 64px icon rail to give the page full width.
    navRail?: boolean
  }
}

export const RootRouter = createRouter({
  // base: '/app',
  history: createWebHashHistory(),
  routes: guardAllRoutes([
    {
      path: '/',
      name: 'marketing',
      component: () => import('@/view/MarketingView.vue'),
      meta: {
        navRail: true,
      },
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/view/UsersView.vue'),
    },
    {
      path: '/fb-api-stats',
      name: 'fb-api-stats',
      component: () => import('@/view/FbApiStatsView.vue'),
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: () => import('@/view/JobsDashboardView.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/LoginView.vue'),
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/accept-invitation',
      name: 'accept-invitation',
      component: () => import('@/view/AcceptInvitationView.vue'),
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/view/ForgotPasswordView.vue'),
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/view/ResetPasswordView.vue'),
      meta: {
        isPublic: true,
      },
    },
  ]),
})

export class RootRoute {
  static login(currentPath: string): RouteLocationRaw {
    if (currentPath === '/login' || currentPath.startsWith('/login?')) {
      return currentPath
    } else {
      return currentPath && currentPath !== '/'
        ? { name: 'login', query: { redirect: currentPath } }
        : { name: 'login' }
    }
  }

  static loginFromCurRoute(): RouteLocationRaw {
    return this.login(RootRouter.currentRoute.value.fullPath)
  }
}


/**
 * Guard the route from unauthorized users.
 *
 * @param  {RouteLocationNormalized} to The route we want to access.
 * @return {void}
 */
function guardRoute(to: RouteLocationNormalized): RouteLocationRaw | void {
  if (!AuthStore.module.isAuthorized) {
    return RootRoute.login(to.fullPath)
  }
}

function guardAllRoutes(routes: AppRoute[]): RouteRecordRaw[] {
  return routes.map((route: any) => ({
    ...route,
    beforeEnter: (to: RouteLocationNormalized) => {
      // Setup some per-page stuff.
      // document.title = route.title
      // store.dispatch('common/updateTitle', route.title)
      // RootStore.dispatch('updateLayout', route.layout)
      // RootStore.dispatch('checkForUpdate')

      // Auth navigation guard.
      if (!route.meta?.isPublic) return guardRoute(to)
    },
  }))
}